import React, { Component }  from 'react';
import Section from "./Section";
import FixedPanel from "./FixedPanel";
import EmailForm from  "./EmailForm";
import Curve from "./Curve";
import FixedButton from "./FixedButton";
import ExpandableView from "./ExpandableView";
import Player from "./Player";
import {onDownloadStart} from "../services/Statistics";


const link='https://s3.eu-central-1.amazonaws.com/naura-builds/vna-mir.exe';
export default class HomePage extends Component{
    onInfo=()=>{
        this.setState({isInfo: true});
    };
    onToggleInfo=()=>{
        this.setState({isInfo: !this.state.isInfo});
    };
    onInfoClose=()=>{
        this.setState({isInfo: false});
    };
    buttons=[
        {
            id:'buy',
            src:'../images/buttons/buy.png',
            srcOn: '../images/buttons/buy_on.png',
            handler:()=>{}
        },
        {
            id:'info',
            src:'../images/buttons/info.png',
            srcOn: '../images/buttons/info_on.png',
            handler: this.onToggleInfo
        },
        {
            id:'system',
            src:'../images/buttons/system.png',
            srcOn: '../images/buttons/system_on.png',
            handler:()=>{}
        },
        {
            id:'agree',
            src:'../images/buttons/agree.png',
            srcOn: '../images/buttons/agree_on.png',
            handler:()=>{}
        }
    ];
    state={
        isInfo:false
    };

    onEmailChanged=(email)=>{
    this.setState({email: email});
    };
    onDownload=()=>{
        const message={
            email: this.state.email,
            source:'landing',
            link:link
        };
        onDownloadStart(message);
    };
    constructor(props) {
        super(props);
    }
    render(){
    return <div>
        <Player isPlaying={this.state.isInfo} handleFinish={this.onInfoClose}/>
    <Section id='home'>
      <div className='imgbox'>
          <img className='center-fit' src='../images/back_naurasha.jpg'/>
          <a className='bottom-center' href={link} download>
                <img className='fill'  src='../images/button_download.png' onClick={this.onDownload} />
          </a>
          <Curve cname="bottom-curve-down" height="80" color="#1a1246"/>
          <div className='flex-text-description'>
              <div className="middle-part">
              <p>«Вселенная научных развлечений» — это уникальный образовательный комплекс.
                  В него входят эксперименты и игры с физическими датчиками, а также множество интересных фактов,
                  изложенных в доступной форме и озвученных Николаем Николаевичем Дроздовым. Выбирайте Вселенную, в которой будут жить ваши дети!</p>
              </div>
          </div>
      </div>
    </Section>
        <Section id='buy'>
            <div className='email-container'>
                <div className='flex-header'>
                    <p>Свяжитесь с нами, чтобы заказать оборудование</p>
                    <EmailForm handler={this.onEmailChanged}/>
                </div>
            </div>
        </Section>
        <Section id='system'>
            <div className='system-container'>
                <img className='in-the-middle'  src="../images/buttons/system_gray.png"/>
                <div className='flex-text-s'>
                    <h4>Системные требования</h4>
                    <ul>
                        <li>
                            Система: Windows 8; 10
                        </li>
                         <li>
                             Процессор: Intel Core i3 3ГГц;
                        </li>
                         <li>
                             Память: 4096 Мб;
                        </li>
                         <li>
                             Видео-карта: с ОЗУ 512 Мб, совместимая с DirectX 9.0c и поддерживающая разрешение экрана 1920*1080;
                        </li>
                         <li>
                             Аудио-карта: совместимая с DirectX;
                        </li>
                         <li>
                             Жесткий диск: 5 Гб свободного места;
                        </li>
                         <li>
                             DirectX 9.0c.
                        </li>

                    </ul>
                </div>
            </div>
        </Section>
        <Section id='agree'>

            <ExpandableView cls='agree-container' cls_collapsed='agree-collapsed' show_allways='0' show_collapsed='1' show_expanded='2'>
                <img className='in-the-middle'  src="../images/buttons/agree_gray.png"/>
                <div className='flex-text-collapsed'>
                    <h4>Лицензионный договор с конечным пользователем.</h4>
                    <p>
                        Настоящий документ является договором присоединения, заключаемым в порядке пункта 5 статьи 1286 Гражданского кодекса Российской Федерации.</p>
                    <p>
                        Термины.
                    </p>
                    <p>
                        Договор – настоящий документ со всеми приложениями, изменениями, дополнениями, размещенными на носителе с записью Продукта, а также на Сайте Правообладателя, как имеющиеся и действующие на момент присоединения к настоящему Договору, так теми, которые произойдут в будущем.
                        Правообладатель – Поваляев Олег Александрович, 16.04.1957 г.р.,
                        Пользователь – физическое лицо, присоединяющееся к настоящему Договору, обладающее достаточной дееспособностью для заключения (присоединения) настоящего Договора.
                        Продукт – программа для ЭВМ и/или база данных, исключительное право на которую принадлежит Правообладателю, работающая исключительно совместно с датчиком/-ами, распространяемым/-ыми в комплекте с экземпляром соответствующей программы для ЭВМ и/или базы данных.
                        Устройство Пользователя – персональный компьютер (стационарный, ноутбук, лэптоп и т.п.), а также мобильные устройства (смартфоны, планшетные компьютеры, плееры) под управлением операционных систем Windows, Android или iOS.
                    </p>
                        <p>
                        Разрешенная территория  - территория всего мира.
                        </p><p>
                        Наименование продукта на русском языке – «Вселенная Научных Развлечений»// «Наураша в стране Наурандии».
                        Сайт Правообладателя – сайт в глобальной сети Интернет, размещенный под доменным именем www.naurasha.ru
                </p>
            </div>
                    <div className='flex-text-expanded'>
                        <h4>Лицензионный договор с конечным пользователем.</h4>
                        <p>
                            Настоящий документ является договором присоединения, заключаемым в порядке пункта 5 статьи 1286 Гражданского кодекса Российской Федерации.</p>
                        <p>
                            Термины.
                        </p>
                        <p>
                            Договор – настоящий документ со всеми приложениями, изменениями, дополнениями, размещенными на носителе с записью Продукта, а также на Сайте Правообладателя, как имеющиеся и действующие на момент присоединения к настоящему Договору, так теми, которые произойдут в будущем.
                            Правообладатель – Поваляев Олег Александрович, 16.04.1957 г.р.,
                            Пользователь – физическое лицо, присоединяющееся к настоящему Договору, обладающее достаточной дееспособностью для заключения (присоединения) настоящего Договора.
                            Продукт – программа для ЭВМ и/или база данных, исключительное право на которую принадлежит Правообладателю, работающая исключительно совместно с датчиком/-ами, распространяемым/-ыми в комплекте с экземпляром соответствующей программы для ЭВМ и/или базы данных.
                            Устройство Пользователя – персональный компьютер (стационарный, ноутбук, лэптоп и т.п.), а также мобильные устройства (смартфоны, планшетные компьютеры, плееры) под управлением операционных систем Windows, Android или iOS.
                        </p>
                        <p>
                            Разрешенная территория  - территория всего мира.
                        </p><p>
                        Наименование продукта на русском языке – «Вселенная Научных Развлечений»// «Наураша в стране Наурандии».
                        Сайт Правообладателя – сайт в глобальной сети Интернет, размещенный под доменным именем www.naurasha.ru
                    </p>
                    <p>
                        1.	Предмет договора
                </p><p>
                        1.1.	Согласно настоящему Договору, Правообладатель предоставляет Пользователю простую (неисключительную) лицензию в объеме, определенном настоящим Договором, исключительно для использования в домашних условиях.
                </p><p>
                        1.2.	Правообладатель предоставляет Пользователю право использования Продукта следующими способами:
                </p><p>
                        1) осуществлять установку (запись и хранение) Продукта на Устройство Пользователя (не более двух Устройств Пользователя);
                </p><p>2) осуществлять использование Продукта по его функциональному назначению;
                </p><p>1.3.	Пользователь вправе использовать Продукт исключительно в пределах Разрешенной территории.
                </p><p>1.4.	Пользователь вправе использовать Продукт в течение неограниченного срока при условии соблюдения условий настоящего Договора.
                </p><p>1.5.	Пользователь считается присоединившимся к настоящему Договору с момента начала использования Продукта. Присоединение Пользователя к настоящему Договору означает заключение Пользователем с Правообладателем Договора на приведенных в нем условиях. С момента присоединения Пользователя к настоящему Договору Пользователь считается принявшим условия настоящего Договора в полном объеме без каких-либо оговорок и/или исключений. В случае несогласия Пользователя с какими-либо из положений Договора, Пользователь не вправе использовать Продукт.
                </p><p>1.6.	Системные и иные технические требования, предъявляемые к компьютерам Пользователя для работы Продукта:

                </p><p>  Система: Windows 8; 10
                </p><p>    Процессор: Intel Core i3 3ГГц;
                </p><p>    Память: 4096 Мб;
                </p><p>  Видео-карта: с ОЗУ 512 Мб, совместимая с DirectX 9.0c и поддерживающая разрешение экрана 1920*1080;
                </p><p>   Аудио-карта: совместимая с DirectX;
                </p><p>   Жесткий диск: 4 Гб свободного места;
                </p><p>    DirectX 9.0c.
                </p><p>   Net Framework 3.5.
                </p><p>   2.	Ограничения.
                </p><p> 2.1.	Пользователь не вправе передавать сам Продукт (оригинал, копию, экземпляр), либо права использования Продукта третьим лицам.
                </p><p>   2.2.	Пользователь не вправе осуществлять следующие действия:
                </p><p>   2.2.1.	Использовать Продукт и/или любые его элементы любым способом (воспроизведение, распространение, публичное исполнение, публичный показ, доведение до всеобщего сведения и т.д.) в условиях, отличных от использования в домашних условиях;
                </p><p>    2.2.2.	Осуществлять переработку Продукта, в т.ч. осуществлять перевод Продукта на другие языки и/или создание производных произведений с использованием Продукта;
                </p><p>    2.2.3.	Исследовать программный код и/или декомпилировать Продукт и/или его части;
                </p><p>    2.2.4.	Использовать Продукт способами, не предусмотренными настоящим Договором;
                </p><p>     2.2.5.	вносить какие-либо изменения в Продукт, в т.ч.  необходимые для функционирования Продукта и исправления явных ошибок. В случае необходимости внесения таких изменений, Пользователь обязуется обратиться к Правообладетелю;
                </p><p>   2.2.6.	изготавливать копию Продукта, в т.ч. когда эта копия предназначена только для архивных целей или для замены правомерно приобретенного экземпляра в случаях, когда такой экземпляр утерян, уничтожен или стал непригоден для использования. В случае утраты, уничтожения или непригодности для использования экземпляра Продукта, для восстановления экземпляра Продукта Пользователь обязуется обратиться к Правообладателю с указанием индивидуального кода, присвоенного при первой установке Продукта. При этом копия Продукта не может быть использована в иных целях, чем цели, указанные в подп.1 – 2  настоящего пункта 1.2. Договора, и должна быть уничтожена, если владение экземпляром таких программы или базы данных перестало быть правомерным.
                </p><p>   2.3.	Использование Продукта допускается исключительно физическими лицами и исключительно в домашних условиях. НЕ допускается использование Продукта юридическими лицами, в т.ч. образовательными организациями, в т.ч. не допускается демонстрация оригинала или копии Продукта обучающимся и/или педагогическим работникам в рамках проведения аудиторных занятий, а также демонстрация/использование на выставках, платных и/или бесплатных мастер-классах.
                </p><p>    3.	Интеллектуальные права на Продукт.
                </p><p>    3.1.	Правообладателю принадлежат имущественные права на Продукт, а также все объекты интеллектуальной собственности, включенные в Продукт, в том числе тексты, изображения, персонажи, дизайн, иллюстрации, аудиовизуальные произведения, фонограммы, исполнения, программы для ЭВМ, базы данных, товарные знаки и т.д. (далее – «Элементы Продукта»).
                </p><p>     3.2.	Использование Продукта и/или Элементов Продукта допускается исключительно в соответствии с условиями настоящего Договора и не могут быть использованы иными способами, не предусмотренными настоящим Договором, без предварительного письменного разрешения Правообладателя.
                </p><p>    4.	Ответственность Пользователя.
                </p><p>     4.1. Правообладатель вправе расторгнуть настоящий Договор в одностороннем внесудебном порядке без уведомления об этом Пользователя в случае нарушения Пользователем условий настоящего Договора. С момента такого расторжения Пользователь утрачивает право использовать Продукт каким бы то ни было способом, а Правообладатель вправе заблокировать функционирование Продукта на Устройстве Пользователя.
                </p><p>    4.2. Использование Пользователем Продукта с нарушением условий настоящего Договора влечет привлечение Пользователя к ответственности за нарушение исключительных прав на Продукт в соответствии с гражданским, административным и уголовным законодательством по усмотрению Правообладателя.
                </p><p>    5.	Гарантии Правообладателя.
                </p><p>    5.1.	Правообладатель гарантирует работоспособность Продукта при условии использования Продукта на Устройствах Пользователя, отвечающих предъявляемым системным требованиям к таким Устройствам Пользователя. При этом Правообладатель не гарантирует, что Продукт будет свободен от ошибок и что все ошибки будут обнаружены и исправлены.
                </p><p>     5.2.	Правообладатель гарантирует бесплатное консультационно-информационное обслуживание Продукта для Пользователей в течение 3 (трех) лет с момента обнародования Продукта.
                </p><p>     5.3.	Лицензиар не гарантирует, что Продукт будет полностью отвечать представлениям (в том числе, но не только эстетическим), ожиданиям, потребностям Пользователя.
                </p><p>     5.4.	Правообладатель не несет ответственности перед Пользователем в случае, если установка и/или использование Пользователем Продукта осуществлялись с нарушением требований сопроводительной документации и/или условиями настоящего Договора.
                </p><p>    5.5.	Пользователь понимает и соглашается с тем, что Правообладатель предоставляет Продукт в состоянии «как есть» («as is») и не дает гарантий в отношении Продукта, кроме прямо указанных в данном Договоре. Указанное означает, что Правообладатель не гарантирует, что Продукт будет удовлетворять субъективным требованиям и ожиданиям Пользователя.
                </p><p>    6.	Заключительные положения
                </p><p>    6.1.	Началом использования Продукта Пользователь подтверждает, что:
                </p><p>    6.1.1. Ознакомился с условиями настоящего Договора в полном объеме до начала использования Продукта;
                </p><p>    6.1.2. Принял все условия настоящего Договора в полном объеме и обязуется их соблюдать или прекратить использование Продукта. Если Пользователь не согласен с условиями настоящего Договора или не имеет достаточных правомочий на заключение Договора, Пользователь обязуется незамедлительно прекратить любое использование Продукта.
                </p><p>    6.1.3. Договор (в целом или в части) может быть изменен Правообладателем без какого-либо специального уведомления Пользователя. Новая редакция Договора вступает в силу с момента ее размещения на Сайте Правообладателя, либо доведения до сведения Пользователя в иной удобной форме. В случае если Правообладателем были внесены какие-либо изменения в Договор в порядке, предусмотренном настоящим пунктом Договора, с которыми Пользователь не согласен, Пользователь обязан прекратить использование Продукта.
                </p><p>    6.2.	Разрешение споров. Все споры по Соглашению или в связи с ним подлежат рассмотрению в суде по месту нахождения Правообладателя.
                </p><p>    6.3.	Настоящий Договор, порядок его заключения и исполнения, а также вопросы, не урегулированные настоящим Договором, регулируются действующим законодательством Российской Федерации.
                </p><p>    6.4.	Действующая редакция настоящего Соглашения размещена на сайте Правообладателя и доступна в сети Интернет по адресу: www.naurasha.ru . В случае противоречия между редакцией Договора, включенной в состав распространяемых экземпляров Продукта, и последней редакцией Договора, размещенной на Сайте Правообладателя, приоритет имеет редакция Договора, размещенная на Сайте Правообладателя.
                </p>
                        <p>

                        Редакция от 21.05.2018.

                    </p>
            </div>
            </ExpandableView>
        </Section>
        <div className='middle-part'>
        <p className='centered-text'>&#x24B8; ООО "Научные Развлечения", 2014-2018 г. Техническая поддержка пользователей: +7 (495) 766 24 23,
            8 (800) 505 23 48,
            <a href="mailto:support@naumag.com?Subject=Обращение%20с%20сайта" target="_top">support@naumag.com</a></p>
        </div>
        <div className='fixed-container'>
            <FixedPanel data={this.buttons}/>
            <Curve cname="bottom-curve" height="8vmin" color="#2a1d70"/>
        </div>
        <div className="up-button">
            <FixedButton id="home" src="../images/buttons/up_gray.png" srcOn="../images/buttons/up_on.png" handler={()=>{}}/>
        </div>
    </div> ;
    }
}

